import React from 'react';
import 'styles/App.scss';
import 'styles/utilities.scss';
import 'styles/orderLookUp.scss';
import {
  AuthContext,
  GlobalStateContext,
  useGlobalStateManager,
  useProvideAuth,
} from 'hooks';
import Route from 'Routes';
import { ThemeContext, useThemeManager } from 'hooks/useTheme';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'lib/queryClient';

function App() {
  const authManager = useProvideAuth();
  const themeManager = useThemeManager();
  const globalManager = useGlobalStateManager();
  return (
    <QueryClientProvider client={queryClient}>
      <AuthContext.Provider value={authManager}>
        <GlobalStateContext.Provider value={globalManager}>
          <ThemeContext.Provider value={themeManager}>
            <Route />
          </ThemeContext.Provider>
        </GlobalStateContext.Provider>
      </AuthContext.Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
